// noinspection EqualityComparisonWithCoercionJS

export const APP_NAME = process.env.REACT_APP_APP_NAME ?? 'Tjecko';
export const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8080';
export const APP_URL = process.env.REACT_APP_URL ?? 'http://localhost:3000';
export const STORY_BOOK_URL = process.env.REACT_STORYBOOK_URL ?? 'http://localhost:6006';
export const IS_PRODUCTION = process.env.REACT_APP_IS_PRODUCTION == 'true';